import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';

const DatenschutzPage: React.FC = () => (
  <div className="min-h-screen bg-gray-900 text-gray-100">
    <header className="bg-gray-800 border-b border-gray-700 px-4 sm:px-6 py-4 flex items-center gap-3">
      <Link to="/" className="text-gray-400 hover:text-white flex items-center gap-1">
        <BookOpen className="w-5 h-5" /> Hausaufgabenheft
      </Link>
      <span className="text-gray-600">·</span>
      <h1 className="text-xl font-semibold">Datenschutz</h1>
    </header>

    <main className="max-w-3xl mx-auto p-4 sm:p-6 space-y-6 text-gray-300 leading-relaxed">
      <section className="bg-gray-800 border border-gray-700 rounded-lg p-6 space-y-3">
        <h2 className="text-xl font-semibold text-white">Wer ist verantwortlich?</h2>
        <p>
          Betreiber dieses Dienstes (<code>hw.z84.de</code>) ist der Inhaber der Domain <code>z84.de</code>.
          Für Rückfragen zur Datenverarbeitung: <a href="mailto:hw@z84.de" className="text-blue-400">hw@z84.de</a>.
        </p>
      </section>

      <section className="bg-gray-800 border border-gray-700 rounded-lg p-6 space-y-3">
        <h2 className="text-xl font-semibold text-white">Welche Daten werden gespeichert?</h2>
        <ul className="list-disc list-inside space-y-1 text-sm">
          <li><strong>Account</strong>: E-Mail-Adresse, Name, gewählte Rolle und Klasse, Passwort-Hash (bcrypt, kein Klartext in der DB).</li>
          <li><strong>Schul-Portal-Zugang</strong> (optional): Schulkürzel, Login-E-Mail und Passwort des Portals. Das Passwort wird per <strong>AES-256-GCM verschlüsselt</strong> gespeichert und ausschließlich für die Synchronisation mit dem Schul-Portal verwendet.</li>
          <li><strong>Importierte Inhalte</strong>: Stundenplan, Hausaufgaben, Termine, Vertretungsplan — so, wie sie das Schul-Portal liefert.</li>
          <li><strong>Eigene Inhalte</strong>: Manuelle Hausaufgaben, TODOs, Noten und Zeiterfassung.</li>
          <li><strong>Technisch</strong>: Server-Zugriffs-Logs bei Traefik/Nginx (IP, User-Agent, URL, Statuscode). Keine Tracker, keine Cookies außer dem Auth-Session-JWT im LocalStorage.</li>
        </ul>
      </section>

      <section className="bg-gray-800 border border-gray-700 rounded-lg p-6 space-y-3">
        <h2 className="text-xl font-semibold text-white">Weitergabe an Dritte</h2>
        <ul className="list-disc list-inside space-y-1 text-sm">
          <li><strong>Schul-Infoportal</strong> (<code>schueler.schule-infoportal.de</code>): Nur wenn du deine Portal-Zugangsdaten hinterlegst. Deine Login-Daten werden bei jedem Sync direkt von unserem Server an die Portal-API übertragen.</li>
          <li><strong>Telegram</strong> (<code>api.telegram.org</code>): Nur wenn du eine Telegram-Chat-ID hinterlegst, werden Ereignisse (Login, Portal-Update) dorthin gepusht.</li>
          <li><strong>E-Mail-Versand</strong> (Strato via <code>smtp.strato.de</code>): Für Verifikations-Mails bei der Registrierung.</li>
          <li><strong>Hosting</strong>: Hetzner (Server) und Let's Encrypt (TLS-Zertifikate).</li>
        </ul>
      </section>

      <section className="bg-gray-800 border border-gray-700 rounded-lg p-6 space-y-3">
        <h2 className="text-xl font-semibold text-white">Speicherdauer</h2>
        <p className="text-sm">
          Account-Daten werden so lange aufbewahrt, wie der Account besteht. Zugriffs-Logs werden nach
          wenigen Wochen automatisch rotiert. Bei Account-Löschung werden alle personenbezogenen Daten
          inklusive importierter Inhalte entfernt.
        </p>
      </section>

      <section className="bg-gray-800 border border-gray-700 rounded-lg p-6 space-y-3">
        <h2 className="text-xl font-semibold text-white">Deine Rechte</h2>
        <p className="text-sm">
          Gemäß DSGVO hast du das Recht auf Auskunft, Berichtigung, Löschung und Datenübertragbarkeit
          der dich betreffenden Daten sowie auf Widerspruch gegen die Verarbeitung. Anfragen bitte an{' '}
          <a href="mailto:hw@z84.de" className="text-blue-400">hw@z84.de</a>.
        </p>
      </section>

      <p className="text-sm">
        <Link to="/impressum" className="text-blue-400">Impressum</Link>
        {' · '}
        <Link to="/about" className="text-blue-400">Über das Projekt</Link>
      </p>
    </main>
  </div>
);

export default DatenschutzPage;
